import { mapComputed } from '@/store/utils/mappers';

import {
	isRouteSelected,
	isSelectingWorkflowRoute,
	rootNodeOfRouteSelection,
	lastNodeOfRouteSelection,
	isInSelectedWorkflowRoute,
} from '@/store/modules/workflowGraphs/getters';

export const useSelectionIcon = () =>
	mapComputed({
		isRouteSelected,
		isSelectingWorkflowRoute,
		rootNodeOfRouteSelection,
		lastNodeOfRouteSelection,
		isInSelectedWorkflowRoute,
	});
